module.exports = __webpack_public_path__ + "static/img/RASM800-120_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASM800-120_1.png
// module id = 2f6G
// module chunks = 0